<h1>Error calling SharePoint</h1>
    <p>A fatal error occurred that prevents the application from continuing.
  This is usually caused by SharePoint throttling or network failures.</p>
    <p >
  <a routerLink="/">Go to home page</a>
</p>
